import React from "react";

const TicketClosedEmail: React.FC = () => {
    const htmlContent = `
        <div class="flex justify-center py-8 bg-gray-100 rounded-lg">
            <div class="max-w-[600px] mx-auto bg-white shadow-lg">
                <div class="bg-gradient-to-r from-blue-600 to-blue-700 px-8 py-6">
                    <h1 class="text-white text-2xl font-semibold">Service Desk</h1>
                </div>
                <div class="px-8 py-6">
                    <h2 class="text-2xl font-semibold text-gray-900 mb-4">Ticket Closed</h2>
                    <p class="text-gray-700 mb-6">This ticket has been closed. Thank you for using our Service Desk.</p>
                    <div class="border-l-4 p-4 mb-4 bg-blue-50 border-blue-200 text-blue-800">
                        <p class="font-semibold mb-1">Ticket Permanently Closed</p>
                        <p class="text-sm">This ticket is now archived. If you need further assistance, please submit a new request.</p>
                    </div>
                    <div class="bg-gray-50 p-4 rounded-md mb-6">
                        <div class="flex gap-2 mb-2">
                            <span class="font-semibold text-gray-700 min-w-[120px]">Ticket ID:</span>
                            <span class="text-gray-900"><span class="font-mono text-blue-600">#SD-2024-1547</span></span>
                        </div>
                        <div class="flex gap-2 mb-2">
                            <span class="font-semibold text-gray-700 min-w-[120px]">Subject:</span>
                            <span class="text-gray-900">Unable to access customer database</span>
                        </div>
                        <div class="flex gap-2 mb-2">
                            <span class="font-semibold text-gray-700 min-w-[120px]">Opened:</span>
                            <span class="text-gray-900">May 6, 2026 at 2:30 PM</span>
                        </div>
                        <div class="flex gap-2 mb-2">
                            <span class="font-semibold text-gray-700 min-w-[120px]">Closed:</span>
                            <span class="text-gray-900">May 8, 2026 at 6:45 PM</span>
                        </div>
                        <div class="flex gap-2 mb-2">
                            <span class="font-semibold text-gray-700 min-w-[120px]">Total Duration:</span>
                            <span class="text-gray-900">2 days, 4 hours</span>
                        </div>
                        <div class="flex gap-2 mb-2">
                            <span class="font-semibold text-gray-700 min-w-[120px]">Status:</span>
                            <span class="text-gray-900"><span class="inline-block bg-gray-100 text-gray-800 px-2 py-1 rounded text-sm font-medium">Closed</span></span>
                        </div>
                    </div>
                    <div class="mb-6">
                        <h3 class="font-semibold text-gray-900 mb-2">Final Summary:</h3>
                        <div class="bg-white border border-gray-200 p-4 rounded">
                            <p class="text-gray-700 text-sm mb-2"><strong class="font-semibold">Issue:</strong> User unable to access customer database</p>
                            <p class="text-gray-700 text-sm mb-2"><strong class="font-semibold">Resolution:</strong> Database permissions were added to user account by DBA team</p>
                            <p class="text-gray-700 text-sm"><strong class="font-semibold">Outcome:</strong> User confirmed successful access to database. Issue resolved.</p>
                        </div>
                    </div>
                    <div class="mb-6">
                        <h3 class="font-semibold text-gray-900 mb-2">Ticket Activity Timeline:</h3>
                        <div class="space-y-2">
                            <div class="flex gap-3 text-sm">
                                <span class="text-gray-500 w-32">May 6, 2:30 PM</span><span class="text-gray-700">Ticket created</span>
                            </div>
                            <div class="flex gap-3 text-sm">
                                <span class="text-gray-500 w-32">May 6, 2:45 PM</span><span class="text-gray-700">Assigned to Marcus Chen</span>
                            </div>
                            <div class="flex gap-3 text-sm">
                                <span class="text-gray-500 w-32">May 6, 3:00 PM</span><span class="text-gray-700">Agent acknowledged ticket</span>
                            </div>
                            <div class="flex gap-3 text-sm">
                                <span class="text-gray-500 w-32">May 6, 3:15 PM</span><span class="text-gray-700">Status changed to Blocked (awaiting DBA approval)</span>
                            </div>
                            <div class="flex gap-3 text-sm">
                                <span class="text-gray-500 w-32">May 6, 5:30 PM</span><span class="text-gray-700">Permissions applied</span>
                            </div>
                            <div class="flex gap-3 text-sm">
                                <span class="text-gray-500 w-32">May 6, 5:45 PM</span><span class="text-gray-700">Ticket marked as resolved</span>
                            </div>
                            <div class="flex gap-3 text-sm">
                                <span class="text-gray-500 w-32">May 8, 6:45 PM</span><span class="text-gray-700">Auto-closed (48 hours after resolution)</span>
                            </div>
                        </div>
                    </div>
                    <div class="flex gap-3 mb-6">
                        <a href="#" class="inline-block bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-md font-medium no-underline transition-colors">View Full Ticket History</a>
                        <a href="#" class="inline-block bg-gray-600 hover:bg-gray-700 text-white px-6 py-3 rounded-md font-medium no-underline transition-colors">Submit New Request</a>
                    </div>
                    <div class="bg-amber-50 border border-amber-200 p-4 rounded mb-6">
                        <h3 class="font-semibold text-gray-900 mb-2">Need to Reopen?</h3>
                        <p class="text-sm text-gray-700 mb-3">If the issue returns or you need further assistance with this matter, you can reopen this ticket within the next 7 days. After that, please submit a new request.</p>
                        <a href="?action=reopen" class="inline-block bg-gray-600 hover:bg-gray-700 text-white px-6 py-3 rounded-md font-medium no-underline transition-colors">Reopen This Ticket</a>
                    </div>
                </div>
                <div class="bg-gray-50 px-8 py-6 border-t border-gray-200">
                    <p class="text-sm text-gray-600">This is an automated message from the Service Desk. Please do not reply directly to this email.</p>
                </div>
            </div>
        </div>
    `;
    return <div dangerouslySetInnerHTML={{ __html: htmlContent }} />;
};

export default TicketClosedEmail;
